import React from "react";
import styled from "styled-components";
import LineButton from "~/components/atoms/ShareButton/LineButton";
import TwitterButton from "~/components/atoms/ShareButton/TwitterButton";
import AmpHelpfulButton from "~/components/modules/qaActions/AmpHelpfulButton";
import HelpfulButton from "~/components/modules/qaActions/HelpfulButton";
import ScrollToTopButton from "~/components/modules/qaFixedHeader/ScrollToTopButton";
import { QuestionAnswer } from "~/models/questionAnswer";

interface TocActionsProps {
  increaseFeedbackHelpfulCallback?: () => void;
  isAmp?: boolean;
  lineShareUrl: string;
  questionAnswerId: QuestionAnswer["id"];
  topicId: QuestionAnswer["topicId"];
  twitterShareUrl: string;
}

const TocActions: React.FC<TocActionsProps> = ({
  increaseFeedbackHelpfulCallback,
  isAmp,
  lineShareUrl,
  questionAnswerId,
  topicId,
  twitterShareUrl,
}) => {
  return (
    <ActionRow>
      {isAmp ? (
        <AmpHelpfulButton />
      ) : (
        <HelpfulButton
          questionAnswerId={questionAnswerId}
          topicId={topicId}
          increaseFeedbackHelpfulCallback={increaseFeedbackHelpfulCallback}
        />
      )}
      <TwitterButton twitterShareUrl={twitterShareUrl} showLabel={false} />
      <LineButton lineShareUrl={lineShareUrl} showLabel={false} />
      <ScrollToTopButton />
    </ActionRow>
  );
};

const ActionRow = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: flex-start;
  margin-bottom: 24px;
`;

export default TocActions;
